import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HttpService } from "../shared/services/http.service";

@Component({
  selector: "app-bulk-contract-dialog",
  templateUrl: "./bulk-contract-dialog.component.html",
  styleUrls: ["./bulk-contract-dialog.component.scss"],
  standalone: false
})
export class BulkContractDialogComponent {
  @Input() selectedClientIds: any[] = []
  @Input() selectedClients: any[] = []
  @Output() close = new EventEmitter<void>()
  @Output() applied = new EventEmitter<void>()

  contractEnd = ''
  applying = false

  get selectedCount(): number {
    return this.selectedClientIds.length
  }

  async apply() {
    if (!this.contractEnd || this.applying) return
    this.applying = true
    try {
      await this.httpService.postAsync('hclient/bulkUpdateContractEnd', {
        clientIds: [...this.selectedClientIds],
        contractEnd: this.contractEnd
      })
      this.applied.emit()
    } finally {
      this.applying = false
    }
  }

  constructor(private httpService: HttpService) {}
}
